import script from "./Upscale.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upscale.vue?vue&type=script&setup=true&lang=ts"

import "./Upscale.scss?vue&type=style&index=0&id=59311097&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59311097"]])

export default __exports__